var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessExchange = function SvgSuccessExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 68c18.778 0 34-15.222 34-34S52.778 0 34 0 0 15.222 0 34s15.222 34 34 34Z",
    fill: "#A79378"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SuccessExchange_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 35.09 3.341-3.466 9.08 9.443L48.657 20 52 23.466 28.42 48 16 35.09Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SuccessExchange_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(16 20)",
    d: "M0 0h36v28H0z"
  })))));
};
export default SvgSuccessExchange;